import { Box, Skeleton } from '@hopskipdrive/react-components';

export const DriverInfoContainer = ({ isFetching, children }) => {
  return (
    <Box mb={3} display="flex" flexDirection="row" alignItems="center" gap="9px">
      {isFetching ? (
        <>
          <Skeleton data-testid="driver-info-skeleton-loader" variant="text" width={10} height={42} />
          <Skeleton variant="text" width={263} height={42} />
          <Skeleton variant="text" width={10} height={42} />
        </>
      ) : (
        children
      )}
    </Box>
  );
};
